import styles from './style.postcss';

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { Map } from 'immutable';
import is from 'is_js';
import PropTypes from 'prop-types';
import { actions as UiState } from 'data/UiState';

import { connect,
  HorizontalSelect,
  StudentCard,
  Card } from 'omni-common-ui';

import { actions as GroupMembers } from 'data/GroupMembers';
import { ProgressTest } from 'data/ProgressTests';
import { checkIsUnitQuiz, getProgressTestPlanFromIndex } from 'data/ProgressTestsPlan/accessors';

export class StudentHorizontalSelect extends Component {
  constructor(props) {
    super(props);

    // used in horizontalselect - kept here to avoid recreating it
    this._getLinkHrefForValue = (studentId) => this.props.buildRoute({
      studentId,
      skillIndex: this.props.skillIndex,
      mode: '',
    });
  }

  componentWillMount() {
    this._buildStudentSelectOptions();
  }

  componentWillReceiveProps(nextProps) {
    this._buildStudentSelectOptions(nextProps);
  }

  _buildStudentSelectOptions(props = this.props) {
    const { studyingMembers, currentMember, currentSkill, progressTest } = props;
    if (is.existy(this._studentSelectOptions) && studyingMembers === this.props.studyingMembers) {
      // cache this - do not recreate each time
      return;
    }
    if (studyingMembers &&
        studyingMembers.size > 0 &&
        currentMember &&
        currentSkill &&
        progressTest) {
      this._studentSelectOptions = studyingMembers.map((member) => {
        const { studentGeneralInfo } = member;
        const optionHtml = <StudentCard vertical
            borderless
            backgroundless>
          <StudentCard.Profile name={studentGeneralInfo.firstName}
              surname={studentGeneralInfo.lastName}
              localName={studentGeneralInfo.localName}
              avatarUrl={studentGeneralInfo.avatarUrl}
              gender={studentGeneralInfo.gender} />
          {this._getStudentScore(studentGeneralInfo.id, props)}
        </StudentCard>;
        return {
          html: optionHtml,
          value: studentGeneralInfo.id,
          className: styles.StudentHorizontalSelect_options,
        };
      });
    }
  }

  _getStudentScore(studentId, props = this.props) {
    const { progressTest: { studentProgressTestResults }, currentSkill: { skillId } } = props;
    const studentProgressTestResult =
      studentProgressTestResults.find((result) =>
      result.studentId === studentId);
    const studentResultForCurrentSkillPercentage =
      studentProgressTestResult &&
      studentProgressTestResult.totalScore.skillScorePercentages.get(skillId);

    const score = is.number(studentResultForCurrentSkillPercentage) ?
      `${studentResultForCurrentSkillPercentage}%` :
      '-';
    const scoreClassName =
      styles.StudentHorizontalSelect_options_score;
    return <StudentCard.Content>
      <Card.Content className={scoreClassName}>
        {score}
      </Card.Content>
    </StudentCard.Content>;
  }

  render() {
    const { currentMember, studyingMembers, currentSkill, isHide } = this.props;
    if (currentMember && currentSkill && studyingMembers.size && studyingMembers.size > 0) {
      return <div className={styles.StudentHorizontalSelect}>
        <HorizontalSelect options={this._studentSelectOptions}
            isHide={isHide}
            value={currentMember.studentGeneralInfo.id}
            getLinkHrefForValue={this._getLinkHrefForValue} />
      </div>;
    }
    return null;
  }

}

StudentHorizontalSelect.propTypes = {
  progressTest: PropTypes.object,
  currentMember: PropTypes.object,
  currentSkill: PropTypes.object,
  studyingMembers: PropTypes.object,
  buildRoute: PropTypes.func,
  pushRoute: PropTypes.func,
  isHide: PropTypes.func,
  skillIndex: PropTypes.string,
  isUnitQuiz: PropTypes.bool,
};

export function mapStateToProps(state, ownProps) {
  const isUnitQuiz = checkIsUnitQuiz(ownProps.location.pathname);
  const { groupId, studentId, skillIndex, progressTestIndex } = ownProps.params;
  const { buildRoute, pushRoute } = ownProps;
  const currentProgressTestId =
    getProgressTestPlanFromIndex(state, groupId, progressTestIndex, isUnitQuiz) &&
    getProgressTestPlanFromIndex(state, groupId, progressTestIndex, isUnitQuiz).id;
  const progressTest = getCurrentProgressTest(state, currentProgressTestId);
  if (currentProgressTestId && progressTest) {
    const progressTestStudentIds = progressTest.data &&
        progressTest.data.studentProgressTestResults.map((studentProgressTestResult) =>
          studentProgressTestResult.studentId);
    const studyingMembers = progressTestStudentIds && GroupMembers.getMembersByGroup(state, groupId)
        .filter((member) => progressTestStudentIds.includes(member.studentGeneralInfo.id));
    const currentMember = GroupMembers.getMemberById(state, studentId);
    return {
      studyingMembers,
      currentMember,
      progressTest: progressTest.data,
      currentSkill: progressTest.data && progressTest.data.skills.get(skillIndex),
      buildRoute,
      pushRoute,
      isHide: ! UiState.getShowNavigationBar(state),
      skillIndex,
      isUnitQuiz,
    };
  }
}

function mapDispatchToProps(dispatch) {
  return Object.assign({},
    bindActionCreators(ProgressTest.actions, dispatch)
  );
}

function getCurrentProgressTest(state, progressTestId) {
  const progressTests = state.get('rootReducer').get('progressTests');
  if (! Map.isMap(progressTests) || ! is.existy(progressTestId)) {
    return;
  }
  return progressTests.get(progressTestId);
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentHorizontalSelect);



// WEBPACK FOOTER //
// ./containers/Group/ProgressTest/StudentHorizontalSelect/index.jsx